import React, { useState } from 'react';

import CryptoPowerlistRow from './CryptoPowerlistRow';

const CryptoPowerlist = ({ data }) => {
  const [details, setDetails] = useState({});

  return (
    <>
      <div className="container-fluid" id="operators-section">
        <div className="title-container">
          <div className="section-title">Operators</div>
          <div className="operators-underline"></div>
        </div>
        <div className="col-sm-10 col-sm-offset-1 mt2">
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.operators.slice(0, 3)}
            isOperatorsSection={true}
          />
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.operators.slice(3, 5)}
            isOperatorsSection={true}
          />
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.operators.slice(5, 8)}
            isOperatorsSection={true}
          />
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.operators.slice(8)}
            isOperatorsSection={true}
          />
        </div>
      </div>
      <div className="container-fluid" id="investors-section">
        <div className="col-sm-10 col-sm-offset-1 mt2">
          <div className="title-container">
            <div className="section-title">Investors</div>
            <div className="investors-underline"></div>
          </div>
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.investors.slice(0, 3)}
          />
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.investors.slice(3, 5)}
          />
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.investors.slice(5, 8)}
          />
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.investors.slice(8)}
          />
        </div>
      </div>
      <div className="container-fluid" id="emerging-section">
        <div className="col-sm-10 col-sm-offset-1 mt2">
          <div className="title-container">
            <div className="section-title">Up & Comers</div>
            <div className="emerging-underline"></div>
          </div>
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.emerging.slice(0, 3)}
          />
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.emerging.slice(3, 5)}
          />
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.emerging.slice(5, 8)}
          />
          <CryptoPowerlistRow
            details={details}
            setDetails={setDetails}
            section={data.emerging.slice(8)}
          />
          <div className="reference-row">
            <div className="reference-notes">
              Data are of March 1, 2022. Interactive by Haejin Park, Mack Cooper and Mike Sullivan.
              {'\n'}
              Typography by Justin Bihan via VTF
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CryptoPowerlist;
